export const formatDate = (dateValue, { includeTime = false } = {}) => {
  if (!dateValue) return '-';
  let date = new Date(dateValue);
  if (isNaN(date.getTime()) && typeof dateValue === 'string') {
    date = new Date(dateValue.replace(' ', 'T'));
  }
  if (isNaN(date.getTime())) return '-';
  return includeTime
    ? date.toLocaleString('es-ES')
    : date.toLocaleDateString('es-ES');
};
